import { css } from 'lit';

export const guildProfileEditViewStyles = css`

  sl-divider.full-width {
    margin-top: var(--view-item-spacing);
    margin-bottom: var(--view-item-spacing);
  }

  sl-tag.visibility-tag {
    margin-bottom: 2rem;
  }
    
  sl-tag.visibility-tag sl-icon {
    margin-right: 0.5rem;
  }

  button-bar {
    gap: 1rem;
    margin-top: var(--view-item-spacing);
  }
  
`;
